import { render, staticRenderFns } from "./DeleteUserOverlay.vue?vue&type=template&id=a8e82bb0&scoped=true&"
import script from "./DeleteUserOverlay.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUserOverlay.vue?vue&type=style&index=0&id=a8e82bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e82bb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
